export const daysShortcuts = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const initialMinMaxDates = { min: undefined, max: undefined };

export const hoursFormatted = Array.from({ length: 24 }, (_, i) => `${`0${i}`.slice(-2)}:00`);
